"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("../../icons");
var Chip = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'neutral' : _b, _c = _a.coloredIcon, coloredIcon = _c === void 0 ? false : _c, Icon = _a.icon, id = _a.id, label = _a.label, onRemove = _a.onRemove, variant = _a.variant, props = __rest(_a, ["color", "coloredIcon", "icon", "id", "label", "onRemove", "variant"]);
    var onRemoveClick = function () { return onRemove(id); };
    var onRemoveKeyDown = function (event) {
        if (event.key === 'Enter')
            onRemove(id);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({}, props, { id: id, className: (0, classnames_1.default)('chip', variant ? "chip-".concat(variant, "-").concat(color) : "chip-".concat(color)), "data-testid": "chip" }, { children: [Icon && ((0, jsx_runtime_1.jsx)(Icon, { "data-testid": "chip-icon", className: (0, classnames_1.default)('chip-icon-prefix', {
                    'text-default': variant !== 'solid' && (color === 'neutral' || !coloredIcon),
                }) })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "chip-label" }, { children: label })), (0, jsx_runtime_1.jsx)("button", __assign({ className: "btn-close-inline chip-remove rounded-circle", onClick: onRemoveClick, onKeyDown: onRemoveKeyDown }, { children: (0, jsx_runtime_1.jsx)(icons_1.Remove16, {}) }))] })));
};
exports.Chip = Chip;
